module.exports = __webpack_public_path__ + "img/brands-harrys-bg-2.png?fbe6dad16337c7873452cc03ed5c9e9e";